<template lang="pug">
    component(:is="layout")
      router-view(:key="$route.fullPath")
</template>

<script>
import DefaultLayout from './layouts/default'
import NotFound from '@/views/404'

export default {
  name: 'app',
  components: {
    DefaultLayout,
    NotFound
  },
  computed: {
    layout() {
      return 'DefaultLayout'
    }
  }
}
</script>
